<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách học sinh đăng ký tuyến xe"
          :link="[
            {
              text: 'Danh sách học sinh',
              href: '../studentBusList'
            }
          ]"
        />
      </div>
      <div class="flex-center">
        <!-- <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn> -->
        <v-btn class="ml-6" depressed dark color="primary" @click="newDialog = !newDialog"> Thêm học sinh mới </v-btn>
      </div>
    </div>

    <v-card v-if="role.type !== 'studentBuslist'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <StudentBusFilter :defaultFilters="defaultBusFilters" @onFilterChanged="refresh" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <StudentBusDataTable ref="busesDataTable" />
    </v-card>
    <BusStudentNewDialog :state="newDialog" @done="refresh" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapGetters } from 'vuex'
import StudentBusFilter from '@/modules/bus/StudentBusFilter'
import StudentBusDataTable from '@/modules/bus/StudentBusDataTable.vue'
import utils from '@/plugins/utils'
import BusStudentNewDialog from '../../modules/bus/BusStudentNewDialog.vue'

export default {
  components: {
    Breadcrumbs,
    StudentBusFilter,
    StudentBusDataTable,
    BusStudentNewDialog
  },
  props: {},
  data() {
    return {
      newDialog: false,
      selected: [],
      defaultBusFilters: {},
      description: '',
      name: '',
      status: '',
      driver: '',
      phone: '',
      data: {
        maxStudent: ''
      },
      maxStudent: '',
      statusDefault: 'active'
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role', 'user', 'isEditDocument'])
  },
  methods: {
    async refresh(query) {
      this.$refs.busesDataTable.refresh(query)
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.studentDataTable.headers]
        headers.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const filters = this.$refs.studentDataTable.$options.filters
        const list = await this.fetchStudents({ ...this.studentSearchParams, _limit: -1 })
        const students = JSON.parse(JSON.stringify(list))
        const data = students.map(item => {
          item.currentClass = filters.getCurrentClass(item.currentClass)
          return item
        })
        utils.exportExcel(data, excelHeader, 'DanhSachHocSinhDangKyXeTuyen')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  created() {
    this.status = this.statusDefault
  }
}
</script>
